import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.items,
        "row-key": 'purchase_id',
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        scroll: { x: 1360 },
        class: "text-nowrap align-middle supplier-report-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_supplier_reports_found`)), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(record.created_at)), 1)
              ], 64))
            : (column && column.key === 'invoice_total')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.invoice_total)), 1)
                ], 64))
              : (column && column.key === 'paid')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.paid)), 1)
                  ], 64))
                : (column && column.key === 'due')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.due)), 1)
                    ], 64))
                  : (column && column.key === 'status')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: _normalizeClass(["status-badge", _ctx.getStatusClass(record.status)])
                      }, _toDisplayString(_ctx.formatLabel(record.status)), 3))
                    : (column && column.key === 'payment_status')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: _normalizeClass(["status-badge", _ctx.getPaymentStatusClass(record.payment_status)])
                        }, _toDisplayString(_ctx.formatLabel(record.payment_status)), 3))
                      : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "onChange"])
    ])
  ]))
}